import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import { Link, Redirect } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/modal.css";
import COLORS from "../resources/colors/COLORS";
import myToast from "../Utils/MyToast";

const MdlSelectSingleStaff = ({ actionClose, actionHandleSelected }) => {
  const [loggedIn, setLoggedIn] = useState(
    localStorage.getItem("token") !== null
  );
  const [loading, setLoading] = useState(false);
  const [loadingStaff, setLoadingStaff] = useState(false);
  const [show, setShow] = useState(true);

  const [StaffList, setStaffList] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(null);

  useEffect(() => {
    getStaffList();
  }, []);

  const getStaffList = () => {
    setLoadingStaff(true);
    setStaffList([]);

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getStaff.php?";
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}${FUNCTION_NAME}`;

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoadingStaff(false);
        if (response.api_status === "OK") {
          setStaffList(response.staff);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoadingStaff(false);
        console.error("Error fetching staff:", error);
      });
  };

  const handleStaffSelection = (staff) => {
    setSelectedStaff(staff);
  };

  const handleConfirmSelection = () => {
    if (selectedStaff) {
      actionHandleSelected(selectedStaff);
      actionClose();
    } else {
      myToast.notify_warning("Please select a staff member");
    }
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  return (
    <div>
      <Modal
        show={show}
        onHide={actionClose}
        animation={false}
        className="fullscreen-modal hide-scrollbar"
        dialogClassName="fullscreen-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>Select Staff Member</Modal.Title>
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <Button
              className="margin_0 gravity_center"
              variant="outline-secondary"
              onClick={actionClose}
              style={{ fontSize: "2rem", height: "30px" }}
              title="Close"
            >
              &times;
            </Button>
            <Button
              className="margin_0"
              variant="primary"
              size="sm"
              onClick={handleConfirmSelection}
              disabled={!selectedStaff}
              style={{ fontSize: "1rem", height: "30px" }}
            >
              {selectedStaff ? "Confirm Selection" : "Select a Staff Member"}
            </Button>
          </div>
        </Modal.Header>

        <Modal.Body className="hide-scrollbar">
          {loading && (
            <div>
              <MyLoader />
            </div>
          )}
          <div className="row settings-scroll">
            <div className="col-md-12 padding_0">
              <div className="gravity_center mb-4">
                <h3 className="text-primary">
                  {selectedStaff ? `Selected: ${selectedStaff.staff_name}` : "No staff selected"}
                </h3>
              </div>
              
              <div className="row bg_card_primary_outline" style={{ margin: "2px 10px", padding: "5px" }}>
                {loadingStaff ? (
                  <div className="col-12 text-center">
                    <MyLoader />
                  </div>
                ) : (
                  StaffList.map((item, index) => (
                    <div key={index} className="col-md-6 col-lg-4 padding_0">
                      <div
                        className={
                          selectedStaff && selectedStaff.staff_id === item.staff_id
                            ? "bg_card_green_outline margin_5 padding_5"
                            : "bg_card_grey_outline margin_5 padding_5"
                        }
                        style={{ 
                          cursor: "pointer",
                          borderRadius: "10px",
                          transition: "all 0.3s ease",
                          minHeight: "100px"
                        }}
                        onClick={() => handleStaffSelection(item)}
                      >
                        <div className="d-flex align-items-center">
                          <div className="me-3">
                            <div
                              className="circular_image"
                              style={{
                                width: "70px",
                                height: "70px",
                                borderRadius: "50%",
                                overflow: "hidden"
                              }}
                            >
                              <img 
                                src={item.staff_image_path} 
                                alt="" 
                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                              />
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <h5 className="mb-1 fw-bold">{item.staff_name}</h5>
                            <p className="mb-1 text-muted ">
                              <strong>Department:</strong> {item.department_name}
                            </p>
                            <p className="mb-0 text-muted ">
                              <strong>Role:</strong> {item.staff_role}
                            </p>
                          </div>
                          <div className="ms-2">
                            {selectedStaff && selectedStaff.staff_id === item.staff_id && (
                              <div
                                style={{
                                  background: "#28a745",
                                  color: "white",
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: "18px"
                                }}
                              >
                                ✓
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MdlSelectSingleStaff;
